var Block_Cards_Modulaire = {

    array_swiper: [],

    init: function () {
        $(window).resize(function () {
            Block_Cards_Modulaire.resize();
        });
        Block_Cards_Modulaire.resize();
    },
    resize: function () {



        $(".block-cards-modulaire").each(function () {

            var _h_header = 0;

            $(this).find(".swiper-slide").each(function(){
                $(this).find(".card-header").css({height:"auto"});
                _h_header = Math.max(_h_header, $(this).find(".card-header").outerHeight());
            });

            $(this).find(".card-header").css({height:_h_header});

            var _slides_to_show = 0;
            var _id = $(this).attr("id");
            var el = document.getElementById(_id);
            _slides_to_show = parseInt(window.getComputedStyle(el).getPropertyValue("--nbslide"));

            if (_slides_to_show != 0) {
                Block_Cards_Modulaire.createSwiper(_id, _slides_to_show);
            } else {
                Block_Cards_Modulaire.destroySwiper(_id);
            }
        })

    },
    createSwiper: function (pID, _slides_to_show) {

        if (!$("#" + pID + " .slider-container").hasClass("swiper-initialized")) {

            var swiper = new Swiper(
                "#" + pID + " .slider-container",
                {
                    speed: 600,
                    loop: false,
                    slidesPerView: "auto",
                    centeredSlides: false,
                    freeMode: false,
                    grabCursor: true,
                    mousewheel: false,
                    slideToClickedSlide: false,
                    touchStartPreventDefault: false,
                    preventClicks: true,
                    spaceBetween: 60,
                }
            );

            Block_Cards_Modulaire.array_swiper.push({id: pID, swiper: swiper, nb_slides: _slides_to_show});
        }
    },
    destroySwiper: function (pID) {
        if ($("#" + pID + " .slider-container").hasClass("swiper-initialized")) {
            for (var i = 0; i < Block_Cards_Modulaire.array_swiper.length; i++) {
                if (Block_Cards_Modulaire.array_swiper[i].id == pID) {
                    Block_Cards_Modulaire.array_swiper[i].swiper.destroy();
                    Block_Cards_Modulaire.array_swiper.splice(i, 1);
                }
            }
        }
    }
}

$(window).load(function () {
    if ($(".block-cards-modulaire").length) {
        Block_Cards_Modulaire.init();
    }
})